import styled from 'styled-components/macro';

// TODO: It's not used right now, but it's a useful element
export const StyledTitle = styled.span``;
